export default __webpack_public_path__ + "static/media/_DSC0331.f5cd27c4.JPG";